import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import PrimaryButton from '../../../../Components/Button/PrimaryButton';
import TemporaryDrawer from '../../../../Components/Drawer/Drawer';
import { Filtruoti } from '../../../../Components/filtruoti';
import SurveyAnalyticsComponentExports from '../../../../Components/FormsComponents/Exports';
import {
    actionButtonsContainerStyles,
    actionButtonsGroupStyles,
    filterButtonStyles
} from './styles';

export const ActionButtons = ({ 
    drawer,
    setDrawer,
    setFilter,
    setLoading,
    formType,
    tvarkyta = [],
    tipai,
    atsakymai
}) => {
    const { t } = useTranslation();

    return (
        <Box sx={actionButtonsContainerStyles}>
            <Box>
                {formType === 'Darbuotojo forma' && (
                    <PrimaryButton
                        onClick={() => setDrawer(true)}
                        startIcon={<FilterListIcon />}
                        sx={filterButtonStyles}
                    >
                        FILTRUOTI
                    </PrimaryButton>
                )}

                {drawer && formType === 'Darbuotojo forma' && (
                    <TemporaryDrawer
                        open={drawer}
                        onClose={() => setDrawer(false)}
                    >
                        <Filtruoti 
                            setOn={setDrawer} 
                            setFilter={setFilter}
                            setLoading={setLoading}
                        />
                    </TemporaryDrawer>
                )}
            </Box>

            {tvarkyta.length > 0 && (
                <Box sx={actionButtonsGroupStyles}>
                    <SurveyAnalyticsComponentExports 
                        json={tipai}
                        data={atsakymai}
                    />
                </Box>
            )}
        </Box>
    );
};

export default ActionButtons;
